var template = `
<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><polygon fill="none" points="14 2 18 6 7 17 3 17 3 13 14 2"  stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/><line fill="none"  stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="3" x2="21" y1="22" y2="22"/></svg>
`;

export default {
    template: template
};
